import IframeMessageBroker from '@flywire/internal-components/services/iframeMessageBroker/iframeMessageBroker';
import type { InjectRecipientFieldsAppearanceSettings } from '@flywire/internal-components/services/iframeMessageBroker/model';
import { MESSAGES } from '@flywire/internal-components/services/iframeMessageBroker/model';

import {
  type InternalElementFactoryOptions,
  type RecipientFieldsElementPublicOptions,
  SdkElement
} from '../../../model';
import { EventBus, type EventBusType } from '../../EventBus';
import { createIframe } from '../createIframe';
import { recipientFieldsUrlBuilder } from './recipientFieldsUrlBuilder';

export type RecipientFieldsElementOptions = RecipientFieldsElementPublicOptions &
  InternalElementFactoryOptions;

export const RecipientFieldsElement = (options: RecipientFieldsElementOptions): SdkElement => {
  const { displayMode = 'container' } = options;
  const eventBus = EventBus();

  const mount = (id?: string) => {
    const url = recipientFieldsUrlBuilder(options);
    const { iframe } = createIframe({
      containerId: id,
      src: url,
      displayMode,
      title: 'Flywire Recipient Fields Element',
      containerErrorKey: 'recipientFieldsElementContainerNotPresent'
    });

    sendAppearanceValuesToIframe(
      IframeMessageBroker.getInstance(),
      iframe,
      options.appearance,
      eventBus
    );

    IframeMessageBroker.getInstance().addListener(
      MESSAGES.RECIPIENT_FIELDS_ELEMENT_CHANGED,
      data => {
        eventBus.onEvent('changed', data);
      }
    );
  };

  return {
    mount,
    onEvent: (key, fn) => eventBus.addEvent(key, fn),
    registeredEvents: eventBus.registeredEvents
  };
};

const sendAppearanceValuesToIframe = (
  broker: ReturnType<(typeof IframeMessageBroker)['getInstance']>,
  iframe: HTMLIFrameElement,
  appearance: InternalElementFactoryOptions['appearance'],
  eventBus: EventBusType
) => {
  broker.addListener(MESSAGES.RECIPIENT_FIELDS_ELEMENT_LOADED, () => {
    eventBus.onEvent('loaded', {});
    if (appearance) {
      broker.sendMessage<InjectRecipientFieldsAppearanceSettings>(
        MESSAGES.INJECT_RECIPIENT_FIELDS_APPEARANCE_SETTINGS,
        { appearance: { ...appearance } },
        iframe
      );
    }
  });
};
